import React, { useContext } from 'react';
import assetAccountContext from '../../context/assetAccountContext';
import FixedIncomeChartTable from './portfolioProfile/FixedIncomeChartTable';
import EquitiesChartTable from './portfolioProfile/EquitiesChartTable';
import BackgroundBar from '../styled/BackgroundBar';
import AnalysisTable from '../portfolioReport/AnalysisTable';
import PerformanceTable from '../portfolioReport/PerformanceTable';
import { MAX_HALF_WIDTH_ALLOCATION_BAR_LENGTH } from '../../utils/constants';

import styles from './PortfolioReportRoot.module.scss';

const PortfolioReportRoot: React.FC = () => {
  const { selectedAccount } = useContext(assetAccountContext);

  if (selectedAccount === undefined) {
    return null;
  }

  if (!selectedAccount.monthlyReport) {
    return null;
  }

  const {
    profile: { fixedIncome, sectorAllocations },
    analysis,
    performance
  } = selectedAccount.monthlyReport;

  if (
    fixedIncome === undefined &&
    sectorAllocations.length === 0 &&
    analysis.length === 0 &&
    performance === undefined
  ) {
    return null;
  }

  return (
    <>
      <BackgroundBar
        className={styles['portfolio-reports']}
        contentClassName={styles['portfolio-profile']}>
        <PerformanceTable selectedAccount={selectedAccount} />
      </BackgroundBar>
      <BackgroundBar
        className={styles['portfolio-reports']}
        contentClassName={styles['portfolio-profile']}>
        <FixedIncomeChartTable selectedAccount={selectedAccount} />
        <EquitiesChartTable
          maxBarLength={MAX_HALF_WIDTH_ALLOCATION_BAR_LENGTH}
          selectedAccount={selectedAccount}
        />
      </BackgroundBar>
      <BackgroundBar
        className={styles['portfolio-reports']}
        contentClassName={styles['portfolio-profile']}>
        <AnalysisTable selectedAccount={selectedAccount} />
      </BackgroundBar>
    </>
  );
};

export default PortfolioReportRoot;
